/**
 * Maps a Transloco language code to the Intl/Angular locale the app uses for
 * dates and numbers. Single source of truth — LOCALE_ID (app.config) and every
 * hand-built Intl.DateTimeFormat must agree, or the UI mixes "5 ago" / "Aug 5".
 */
export function intlLocaleOf(lang: string): string {
	if (lang === 'es') return 'es-ES';
	return 'en-GB';
}
